<template>
<!-- snb -->
<nav id="snb">
    <!-- ************************ -->
    <!-- My Page -->
    <section class="snb_sec mypage_wrap">
        <h2>{{$t('TITLE.GLOBAL.MYPAGE')}}</h2>
        <div class="list">
            <ul class="list_mymenu">
                <!-- myPage top 3 -->
                <li v-for="menu in myPageList" :key="menu.menuId">
                    <a href="javascript:" @click="handleMoveMenu(menu)">{{ menu.menuNm }}</a>
                </li>
            </ul>
        </div>
    </section>

    <!-- ************************ -->
    <!-- My Menu -->
    <section class="snb_sec mymenu_wrap">
        <h2>
            {{ $t('TITLE.GLOBAL.MYMENUS') }}
            <a href="javascript:" class="ico_config" :title="$t('BUTTON.GLOBAL.CONFIG')" @click="btnMyMenuConfig">
                <span class="sr_only">{{ $t('BUTTON.GLOBAL.CONFIG') }}</span>
            </a>
        </h2>
        <div class="list">
            <ul class="list_mymenu">
                <!-- myMenus top 3 -->
                <li v-for="menu in myMenusList" :key="menu.menuId">
                    <a href="javascript:" @click="handleMoveMenuByMenuId(menu)">{{ menu.menuNm }}</a>
                </li>
            </ul>
        </div>
    </section>

    <dl class="tree_wrap search_tree">
        <!-- ************************ -->
        <!-- Search by -->
        <dt>{{$t('TITLE.SEARCH.SEARCH.BY')}}</dt>
        <dd>
            <!-- ************************ -->
            <!-- Contents Type -->
            <article class="tree_group">
                <p class="tree_subtitle">{{$t('FIELD.FAST.ADVANCED.CONTENTTYPE')}}</p>
                <ul class="tree_list">
                    <li v-for="subs in searchContents" :key="subs.naviName">
                        <a href="JavaScript:" :class="{ico_tree: subs.naviSubs && subs.naviSubs.length > 0}" @click="toggleContent($event)">
                            <span class="sr_only">tree toggle</span>
                        </a>
                        <span v-if="subs.naviSubs && subs.naviSubs.length > 0" @click="toggleContent($event)">{{subs.naviName}} ({{subs.naviCnt}})</span>
                        <span v-if="!subs.naviSubs || subs.naviSubs.length == 0" @click="reloadSearchContent(subs.naviName)">{{subs.naviName}} ({{subs.naviCnt}})</span>
                        <ul class="tree_sub_list">
                            <li v-for="subs2 in subs.naviSubs" :key="subs2.naviName">
                                <a href="JavaScript:" :class="{ico_tree: subs2.naviTrds && subs2.naviTrds.length > 0}" @click="toggleContent($event)">
                                    <span class="sr_only">tree toggle</span>
                                </a>
                                <span @click="reloadSearchContent(subs.naviCode + '$' + subs2.naviCode)">{{subs2.naviName}} ({{subs2.naviCnt}})</span>
                            </li>
                        </ul>
                    </li>
<!--                    
                    <li v-for="nation in dotcomNations" :key="nation.SITE_CD">
                        <a href="JavaScript:"><span class="sr_only">tree toggle</span></a>
                        <span @click="reloadSearchNation($event, nation.SITE_CD)">Samsung.com {{nation.SITE_CD}}</span>
                    </li>
-->                    
                </ul>
            </article>

            <!-- ************************ -->
            <!-- Product Category -->
            <article class="tree_group">
                <p class="tree_subtitle">{{$t('FIELD.GLOBAL.PRODUCT.CATEGORY')}}</p>
                <ul class="tree_list">
                    <li v-for="subs in searchCategorys" :key="subs.naviCode">
                        <a href="JavaScript:" class="ico_tree" @click="toggleCategory($event)">
                            <span class="sr_only">tree toggle</span>
                        </a>
                        <span @click="toggleCategory($event)">{{subs.naviName}} ({{subs.naviCnt}})</span>
                        <ul class="tree_sub_list">
                            <li v-for="subs2 in subs.naviSubs" :key="subs2.naviCode">
                                <a href="JavaScript:"><span class="sr_only">tree toggle</span></a>
                                <span @click="reloadSearchCategory(subs.naviName + '$' + subs2.naviName)">{{subs2.naviName}} ({{subs2.naviCnt}})</span>
                            </li>
                        </ul>
                    </li>
                </ul>
            </article>
        </dd>
        <!-- ************************ -->
        <!-- Search by -->
        <dt>{{$t('TITLE.SEARCH.WITHIN')}}</dt>
        <dd>
            <ul class="tree_list">
                <li v-for="subs in searchWithins" :key="subs.naviCode">
                    <a href="JavaScript:" class="ico_tree" @click="toggleWithin($event)"><span class="sr_only">tree toggle</span></a>
                    <span @click="toggleWithin($event)">{{subs.naviName}} ({{subs.naviCnt}})</span>
                    <ul class="tree_sub_list">
                        <li v-for="subs2 in subs.naviSubs" :key="subs2.naviCode" class="">
                            <a href="JavaScript:"><span class="sr_only">tree toggle</span></a>
                            <span @click="reloadSearchWithin($event, subs2)">{{subs2.naviName}} ({{subs2.naviCnt}})</span>
                        </li>
                    </ul>
                </li>
            </ul>
        </dd>
    </dl>
    <section class="bn_wrap">
        <ul class="list_banner">
            <li class="bn_box">
                <a href="javascript:" class="ico_support" :title="$t('TITLE.LEFT.MENU.SUPPORT')" @click="btnSupport">{{ $t('TITLE.LEFT.MENU.SUPPORT') }}</a>
            </li>
        </ul>
    </section>

</nav>
<!-- //snb -->
</template>

<script>
import Vue                          from 'vue';
import { mapGetters, mapActions }   from 'vuex';
import _                            from 'lodash';
import $                            from 'jquery';
import axios                        from 'axios';
import qs                           from 'query-string';
import store                        from '@/vuex/store';
import SDLLocale                    from '@/mixin/SDLLocale';
import { SDLUtil, MenuUtil }        from '@/utils';
import { EventBus }                 from '@/utils/EventBus';
import MyMenuConfigPopup            from '~vb/common/MyMenuConfigPopup';

const fetchSearchAllSetting = () => axios.post(`${SDLUtil.API_URL}/basis/knowledge/listMyKnowledgeAllSetup.skp`);
const fetchSearchSetting = workType => axios.post(
    `${SDLUtil.API_URL}/basis/knowledge/listMyKnowledgeSetup.skp`,
    qs.stringify({ WORK_TYPE : workType }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

export default {
    name : 'SearchSnb',
    data() {
        return {
            params: {},
            myPageList: [],
            myMenusList: [],
            searchContents: [],
//            dotcomNations: [],
            searchCategorys: [],
            searchWithins: []
        }
    },
    computed: {
        ...mapGetters({
            menus: 'getMenus',
            myPages: 'getMyPages',
            storeParams: 'getParams',
            userCorpCd: 'getCorpCd',
            loginRhq: 'getLoginRhq',
            deptLevelCd: 'getDeptLevelCd',
            loginSystem: 'getLoginSystem',
        }),
        getUserInfo() {
            return SDLUtil.getLoginedUserInfo();
        },
        getMyPageList() {
            return this.myPages['subMenu'] || [];
        }
    },
    watch: {
        myMenusList(list) {
            this.myMenusList = list;
        },
//        quickCategoryList(list) {
//            this.quickCategoryList = list;
//        }
    },
    methods: {
        ...mapActions(['changeSubsidiary', 'setReturnSystem']),
        // 컴포넌트 생성시 동작
        async initLoad() {
            this.myPageList = this.getMyPageList;
            const resAll    = await fetchSearchAllSetting();
            return resAll.data;
        },
        // myMenus 클릭 시 이벤트
        handleMoveMenuByMenuId(menuObj) {
            let menuId = menuObj.menuId3 || menuObj.menuId2 || menuObj.menuId1;
            let sMenu = _.find(MenuUtil.menuScan(menuId, this.menus), function(m) { return m.menuId == menuId });
            this.handleMoveMenu(sMenu);
        },
        // 메뉴 이동 이벤트
        handleMoveMenu(menu) {
            store.commit(
                'PARAMS',
                Object.assign(
                    this.storeParams,
                    {
                        menuId : menu.menuId,
                        menuGrpCd : menu.menuGrpCd || '',
                        menuGrpDetailCd : menu.menuGrpDetailCd || '',
                        creationYn : menu.creationYn
                    }
                )
            );

            // URL 이 없는 경우
            if (SDLUtil.isNull(menu['connUrl'])) {
                return false;
            }

            let connUrl = menu.connUrl.replace('.skp', '');
            this.$router.push(connUrl);
        },
        // myMenus 조회
        async searchMyMenusList() {
            return await fetchSearchSetting('MENU')
                        .then(res => { this.setMyMenusList({ myMenus: res.data }); })
                        .catch(err => { 
//                            console.log('Err.searchMyMenusList ===> ', err);
                            SDLUtil.errorAlert(err); 
                        });
        },
        // myMenus List 설정
        setMyMenusList(res) {
            // My Menus data setting
            let refineMyMenuslList = [], myMenusList = [];
            if(SDLUtil.isNull(res.myMenus.result)) {
                myMenusList = res.myMenus.rowData;   
            } else {
                myMenusList = res.myMenus.result.rowData;
            }

            if(myMenusList.length > 0) {
                myMenusList = _.sortBy(myMenusList, ["ROW_NUM"]);
                for(let menu of myMenusList) {
                    refineMyMenuslList.push({
                        menuNm: this.setLinkedName(menu.WORK_KEY_1_NM, menu.WORK_KEY_2_NM, menu.WORK_KEY_3_NM),
                        menuId1: menu.WORK_KEY_1 || '',
                        menuId2: menu.WORK_KEY_2 || '',
                        menuId3: menu.WORK_KEY_3 || '',
                    });
                };
                this.myMenusList = refineMyMenuslList;
            }
        },
        // SNB 태그 생성
        setLinkedName(name1, name2, name3) {
            let linkedName = [], gt = " > ";
            if(!SDLUtil.isNull(name1)) { linkedName.push(name1); }
            if(!SDLUtil.isNull(name2)) { linkedName.push(gt); linkedName.push(name2); }
            if(!SDLUtil.isNull(name3)) { linkedName.push(gt); linkedName.push(name3); }
            return linkedName.join("");
        },
        // 중간 : Prodecu Category

        // Snb상단 : Search Page에서 검색 후 LeftSnb에 Contents Type 설정
        searchContentList(obj) {
            this.params = obj.params;
            this.searchContents = obj.subsList;
        },
        // Snb중단 : Search Page에서 검색 후 LeftSnb에 Prodecu Category 설정
        searchCategoryList(obj) {
            this.params = obj.params;
            this.searchCategorys = obj.subsList;
        },
        // Snb하단 : Search Page에서 검색 후 LeftSnb에 Search winthin 설정
        searchWithinList(obj) {
            this.params = obj.params;
            this.searchWithins = obj.subsList;
        },
        // Search within Tree Toggle
        toggleContent(event) {
            let $el = $(event.target).parent('li');
            if ($el.hasClass('active')) $el.removeClass('active');
            else                        $el.addClass('active');
        },
        // Search within Tree Toggle
        toggleCategory(event) {
            let $el = $(event.target).parent('li');
            if ($el.hasClass('active')) $el.removeClass('active');
            else                        $el.addClass('active');
        },
        // Search within Tree Toggle
        toggleWithin(event) {
            let $el = $(event.target).parent('li');
            if ($el.hasClass('active')) $el.removeClass('active');
            else                        $el.addClass('active');

            $el.parent('ul').children('li').children('span').removeClass('text-bold'); // 1-depth
            $el.parent('ul').children('li').children('ul').children('li').children('span').removeClass('text-bold'); // 2-depth
            $el.children('span').addClass('text-bold');
        },
        // Search Contents Type 클릭 시 재검색
        reloadSearchContent(contName) {
            this.params.contName = contName;
//            this.params.dotcomYn = 'N';
            EventBus.$emit('search-snb-reload', this.params);
        },
        // DotcomNations 클릭 시 재검색
/*        
        reloadSearchNation(event, siteCd) {
            let $el = $(event.target).parent('li').parent('ul').children('li');
            $el.children('span').removeClass('text-bold');
            $(event.target).addClass('text-bold');

            this.params.siteCd = siteCd;
            this.params.dotcomYn = 'Y';
            EventBus.$emit('search-snb-reload', this.params);
        },
*/        
        // Search Product Category 클릭 시 재검색
        reloadSearchCategory(cateName) {
            cateName = cateName.replace('&', '##');
            this.params.cateName = cateName;
//            this.params.dotcomYn = 'N';
            EventBus.$emit('search-snb-reload', this.params);
        },
        // Search within 클릭 시 재검색
        reloadSearchWithin(event, subs) {
            let $el = $(event.target).parent('li').parent('ul').parent('li').parent('ul').children('li');
            $el.children('span').removeClass('text-bold');
            $el.children('ul').children('li').children('span').removeClass('text-bold');
            $(event.target).addClass('text-bold');
            $(event.target).parent('li').parent('ul').parent('li').children('span').addClass('text-bold');

            this.params.contName = '';
            this.params.cateName = '';
            this.params.corpName = subs.naviCode
//            this.params.siteCd   = this.dotcomNations[0].SITE_CD;
//            this.params.dotcomYn = 'N';
            EventBus.$emit('search-snb-reload', this.params);
        },
        // My Menu config
        btnMyMenuConfig() {
            SDLUtil.show( MyMenuConfigPopup, { rtnFunc: () => { this.searchMyMenusList(); } }, { height: 'auto' } );
        },

        async btnSupport() {
            let reLoginData = { loginSystem : 'SUPPORT' };
            this.setReturnSystem(this.loginSystem);
            if(Number(this.deptLevelCd) === 1) {
                Object.assign(reLoginData, {
                    topRhqCd : this.loginRhq,
                    topSubsidiaryCd : this.userCorpCd,
                });

            } else {
                Object.assign(reLoginData, {
                    topRhqCd : $('#selectRhqCd :selected').val(),
                    topRhqNm : $('#selectRhqCd :selected').html(),
                    topSubsidiaryCd : $('#selectRhqSubCd :selected').val(),
                    topSubsidiaryNm : $('#selectRhqSubCd :selected').html(),
                });
            };

            SDLUtil.showLoadingBar(true);
            const loginResult = await this.changeSubsidiary(reLoginData)
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    SDLUtil.errorAlert(err);
                });

            this.afterLoginProcess(loginResult);
        },
        // Support 변경 후 처리
        afterLoginProcess(loginResult) {
            if (loginResult) this.gotoMain();
            EventBus.$emit('router-reload');
            SDLUtil.showLoadingBar(false);
        },
        // 메인 호출 이벤트
        gotoMain() {
            window.scrollTo(0, 0);
            this.$router.push(MenuUtil.getSupportMain());
        },
        getNationsBySubsidiary() {
            let url = `${SDLUtil.API_URL}/basis/admin/dotcom/getNationsByCorp.skp`;
            const param = {corpNo : $('#selectRhqSubCd').val()};
            return axios.post(url, qs.stringify(param), {
                   headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                   params: { searchInfo: 'set' }
                })
                .then(resp => {
//                    console.log('Nation.resp ===> ', resp.data.rows);
//                    this.dotcomNations = resp.data.rows;
                });
        },
    },
    mounted() {
//        this.getNationsBySubsidiary(); // 국가 목록 조회
    },
    // keep-alive activated
    activated() {
        this.initLoad()
            .then(res => {
                this.setMyMenusList(res);
            })
            .catch(err => {
                SDLUtil.errorAlert(err);
            });

        // SNB 이벤트 등록
        EventBus.$on('my-menus-reload',       () => { this.searchMyMenusList(); });
        EventBus.$on('search-contents-reload', subsObj => { this.searchContentList(subsObj); });
        EventBus.$on('search-category-reload', subsObj => { this.searchCategoryList(subsObj); });
        EventBus.$on('search-within-reload',   subsObj => { this.searchWithinList(subsObj); });
    },
    // keep-alive deactivated
    deactivated(){
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('my-menus-reload');
        EventBus.$off('search-contents-reload');
        EventBus.$off('search-category-reload');
        EventBus.$off('search-within-reload');
    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/intgSearch/SearchSnb.vue